<div class="flex flex-col">
  <app-ai-ui-context-box class="-mb-3" [context]="effectiveUiContext()" [removable]="true" (removed)="onRemoveContext($event)" />
  <div class="flex items-end gap-2 rounded-radius-secondary bg-background-container-primary px-3 py-2 relative z-10">
    <textarea
      #textarea
      class="flex-1 bg-[transparent] outline-none resize-none lg:text-sm text-foreground-primary-100 placeholder:text-foreground-primary-40 min-h-[22px] max-h-32"
      [attr.placeholder]="'ai-assistant.input.placeholder' | translate"
      rows="1"
      [ngModel]="value()"
      (ngModelChange)="value.set($event)"
      [disabled]="disabled()"
      (keydown)="onKeydown($event)"
      (input)="onInput()"
    ></textarea>
    <button
      type="button"
      class="shrink-0 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed transition-opacity"
      [disabled]="disabled() || !value().trim()"
      (click)="onSubmit()"
    >
      <svg-icon class="text-action-secondary dark:text-action-secondary-text" key="send-24" size="24" />
    </button>
  </div>
</div>
